import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeComponentCodeSkeleton } from './TypeComponentCode'
import type { TypeComponentCodeTabsSkeleton } from './TypeComponentCodeTabs'
import type { TypeComponentCtaLinkSkeleton } from './TypeComponentCtaLink'
import type { TypeComponentHubiloFormSkeleton } from './TypeComponentHubiloForm'
import type { TypeComponentHubspotCtaSkeleton } from './TypeComponentHubspotCta'
import type { TypeComponentHubSpotFormSkeleton } from './TypeComponentHubSpotForm'
import type { TypeComponentLottieSkeleton } from './TypeComponentLottie'
import type { TypeComponentTableSkeleton } from './TypeComponentTable'
import type { TypeComponentVideoSkeleton } from './TypeComponentVideo'
import type { TypeResourceImageSkeleton } from './TypeResourceImage'
import type { TypeSectionBarGraphSkeleton } from './TypeSectionBarGraph'

export interface TypeComponentCardFields {
  internalName?: EntryFieldTypes.Symbol
  headline?: EntryFieldTypes.Symbol
  subtext?: EntryFieldTypes.RichText
  hideSubtextImagesMobile?: EntryFieldTypes.Boolean
  subtextAlignment?: EntryFieldTypes.Symbol<'Center' | 'Left' | 'Right'>
  contentBackgroundColor?: EntryFieldTypes.Symbol<'Indigo Blue' | 'Light Gray' | 'Primary Blue' | 'White'>
  tagline?: EntryFieldTypes.Symbol
  removeTextPadding?: EntryFieldTypes.Boolean
  image?: EntryFieldTypes.AssetLink
  imageDarkMode?: EntryFieldTypes.AssetLink
  asset?: EntryFieldTypes.EntryLink<
    | TypeComponentCodeSkeleton
    | TypeComponentCodeTabsSkeleton
    | TypeComponentHubSpotFormSkeleton
    | TypeComponentHubiloFormSkeleton
    | TypeComponentLottieSkeleton
    | TypeComponentTableSkeleton
    | TypeComponentVideoSkeleton
    | TypeResourceImageSkeleton
    | TypeSectionBarGraphSkeleton
  >
  imageBackgroundColor?: EntryFieldTypes.Symbol<'Indigo Blue' | 'Light Gray' | 'Primary Blue' | 'White'>
  removeImagePadding?: EntryFieldTypes.Boolean
  showHeroImageOnMobile?: EntryFieldTypes.Boolean
  autoAdjustSvgColor?: EntryFieldTypes.Boolean
  actions?: EntryFieldTypes.Array<
    EntryFieldTypes.EntryLink<TypeComponentCtaLinkSkeleton | TypeComponentHubspotCtaSkeleton>
  >
  filterTags?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
}

export type TypeComponentCardSkeleton = EntrySkeletonType<TypeComponentCardFields, 'componentCard'>
export type TypeComponentCard<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeComponentCardSkeleton,
  Modifiers,
  Locales
>

export function isTypeComponentCard<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeComponentCard<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'componentCard'
}
